import {transformNameToTransliteration} from '@utils/transformNameToTransliteration';
import Image from 'next/image';

import {Logo} from '@ui-kit/src/assets/Icons/Logo';

import {AuthorPageInfo} from '@strapi/types/Author';

import styles from './ArticleAuthor.module.scss';

type Props = {
  author: AuthorPageInfo | undefined;
};
export const ArticleAuthor = ({author}: Props) => {
  const authorData = {
    id: author?.id ?? 1,
    name: author?.name ?? 'RuStore',
    position: author?.position ?? 'Магазин приложений для Android',
  };
  return (
    <a
      href={`/authors/${transformNameToTransliteration(authorData.name)}-${authorData.id}`}
      className={styles.author}
      data-testid={'author_info'}
    >
      {author?.Icon.url ? (
        <Image
          src={author?.Icon.url}
          alt=""
          width={40}
          height={40}
          className={styles.icon}
        />
      ) : (
        <Logo className={styles.icon} />
      )}

      <div>
        <p className={styles.name}>{authorData.name}</p>
        <p className={styles.position}>{authorData.position}</p>
      </div>
    </a>
  );
};
